import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-export-list',
  templateUrl: './export-list.component.html',
  styleUrls: ['./export-list.component.scss']
})
export class ExportListComponent implements OnInit {

  @Input() items!: ReadonlyArray<any>
  @Input() defaultSelectAll: boolean = false;
  @Output() change = new EventEmitter<Array<any>>();
  @Output() export = new EventEmitter<Array<any>>();

  private _selected?: Array<any>;

  ngOnInit(): void {
    if(this.defaultSelectAll) {
      this._selected = [...this.items];
    }
  }

  selectionChange(items: Array<any>) {
    this._selected = items;
    this.change.emit(items);
  }

  handleExport() {
    this.export.emit(this._selected);
  }
}
